import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

import RoleProtectedRoute from "../../router/RoleProtectedRoute";
import MonitoreoIaLayout from "./MonitoreoIaLayout";
import { MENU, MONITOREO_IA_BASE, monitoreoIaDefaultRoute } from "./config";

const children: RouteObject[] = [
  { index: true, element: <Navigate to={monitoreoIaDefaultRoute} replace /> },
  ...MENU.map((item) => ({ path: item.id, element: item.element })),
];

export const monitoreoIaRoute: RouteObject = {
  path: MONITOREO_IA_BASE,
  element: <RoleProtectedRoute restrictedRoles={["web_services"]} />,
  children: [
    {
      path: "",
      element: <MonitoreoIaLayout />,
      children,
    },
  ],
};
